<template>
  <!-- @vue-skip TODO: 既存の型エラーを解消したら外す -->
  <div>
    <el-button @click="prevStep">
      <Icon name="arrow-left" space="right" />
      戻る
    </el-button>
    <div class="campaign-create-condition web-instanwin-page">
      <Panel>
        <div class="title-container">
          <FormItemLabel label="ページタイトル" required />
          <el-input
            :maxlength="256"
            type="text"
            :value="form.name"
            placeholder="ページタイトル"
            @input="setPageName"
            @blur="change('page_name')"
          />
        </div>
        <div class="title-name-input-error">
          <div class="empty-label"></div>
          <div v-if="isNameTextEmpty" class="title-input-error">テキストを入力してください。</div>
        </div>
      </Panel>
    </div>
    <div class="campaign-create-condition web-instanwin-page">
      <Panel>
        <div class="condition-item">
          <FormItemLabel label="落選ページ" />
        </div>
        <div class="input-container">
          <div class="label mb-x1">
            <span>落選時テキスト</span>
            <span class="badge badge-danger ml-x1">必須</span>
          </div>
          <EditableComponent
            class="web-instantwin-win-textarea"
            :value="form.lotteryText"
            placeholder="内容を入力"
            @input="setPageLotteryText"
            @blur="change('page_lose_text')"
          />
        </div>
        <div v-if="isPageLoseTextEmpty" class="error-container">
          <div class="empty-label"></div>
          <div class="title-input-error">テキストを入力してください。</div>
        </div>
        <div class="input-container">
          <div class="label mb-x1">
            <span>落選メディア</span>
            <el-tooltip placement="top">
              <div slot="content">
                落選者用に表示するメディアを選択できます。<br />
                未設定の場合、デフォルトのGIF動画が表示されます。
              </div>
              <i class="mdi mdi-help-circle"></i>
            </el-tooltip>
          </div>
          <div
            class="web-instanwin-page-media"
            v-loading="isUploadMediaLoading"
            element-loading-text="画像/動画をアップロードしています。 しばらくお待ちください。"
          >
            <el-button v-if="!form.mediaUrl" type="primary" @click="$refs.loseMediaRef.click()">
              アップロード
            </el-button>
            <div v-if="form.mediaUrl">
              <div class="media-preview">
                <i class="mdi mdi-close" @click="removeMedia"></i>
                <div class="media-name">{{ form.mediaOriginName }}</div>
                <img v-if="isMedia && !form.mediaType" :src="form.mediaUrl" class="direct-media mt-x1" />
                <video
                  v-else-if="isMedia && form.mediaType"
                  :src="form.mediaUrl"
                  class="direct-media mt-x2"
                  controls
                ></video>
              </div>
              <div class="mt-x2">
                <label class="el-button el-button--default" @click="$refs.loseMediaRef.click()">
                  <i class="mdi mdi-image"></i>
                  <span v-if="form.mediaUrl">画像/動画を変更</span>
                </label>
              </div>
            </div>
            <span class="media-limit-text">アップロード可能最大サイズ: 画像5MB 動画25MB</span>
            <input
              type="file"
              style="display: none"
              @change="handleFileChange($event)"
              accept="video/mp4,image/jpeg,image/png,image/pjpeg,image/gif"
              ref="loseMediaRef"
            />
          </div>
        </div>
      </Panel>
    </div>
    <div class="create-web-instanwin-page">
      <el-button
        v-if="mode !== 'edit_win'"
        type="default"
        native-type="submit"
        :disabled="isDeleteDisabled"
        @click="deletePage"
      >
        <i class="mdi mdi-content-save" />
        削除
      </el-button>
      <el-button type="primary" native-type="submit" :disabled="isCreatedLosePageDisabled" @click="createOrUpdatePage">
        <i class="mdi mdi-content-save" />
        {{ mode !== 'edit_lose' ? '新規作成' : '保存' }}
      </el-button>
    </div>
  </div>
</template>
<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { defineComponent } from 'vue'

import EditableComponent from '@/client/components/_atoms/editable/editable.vue'
import Icon from '@/client/components/_atoms/Icon.vue'
import Panel from '@/client/components/_atoms/Panel.vue'
import FormItemLabel from '@/client/components/_molecules/FormItemLabel.vue'
import api from '@/client/core/api'
import TwitterUpload from '@/client/core/twitter_upload'
import { TrackingService } from '@/client/services'
import { Form, useLotteryPageSettingDialogStore } from '@/client/store/useLotteryPageSettingDialogStore'
import { WEB_INSTANTWIN_MEDIA_LOSE_ORIGIN_NAME, WEB_INSTANTWIN_MEDIA_LOSE_URL } from '@/common/constants'

export default defineComponent({
  name: 'LotteryPageCreateDialog',
  components: {
    Icon,
    Panel,
    FormItemLabel,
    EditableComponent
  },
  data() {
    return {
      isUploadMediaLoading: false,
      isMedia: true,
      isChangePageLoseText: false,
      isChangePageName: false
    }
  },
  computed: {
    ...mapState(useLotteryPageSettingDialogStore, ['form', 'mode', 'lotteryPages']),
    isNameTextEmpty(): boolean {
      return this.isChangePageName && !this.form.name.trim()
    },
    isPageLoseTextEmpty(): boolean {
      return this.isChangePageLoseText && !this.form.lotteryText.trim()
    },
    isCreatedLosePageDisabled(): boolean {
      return !this.form.lotteryText || !this.form.name || this.isNameTextEmpty || this.isPageLoseTextEmpty
    },
    isDeleteDisabled(): boolean {
      return !this.lotteryPages.length || this.lotteryPages.filter(v => v.lotteryType === 0).length <= 1
    }
  },

  methods: {
    ...mapActions(useLotteryPageSettingDialogStore, ['setForm', 'setMode', 'fetchLotteryPages']),

    /**
     * アップロード画像・動画ファイルの変更
     */
    async handleFileChange(e: any) {
      TrackingService.sendEvent('click:当落選ページの管理|落選ページの作成|アップロード')

      if (!e.target.files || !e.target.files[0]) {
        return
      }

      this.isUploadMediaLoading = true

      const validFormat = ['video/mp4', 'image/jpeg', 'image/png', 'image/gif', 'image/pjpeg', 'image/gif']

      // メディアをチェック

      const file = e.target.files[0]

      const checkValidMedia = await TwitterUpload.checkValidMedia(file, validFormat)

      if (checkValidMedia.error) {
        const error = checkValidMedia.error

        switch (error) {
          case 'INVALID_MEDIA':
            this.notify('Please upload valid format!', validFormat.join(', '))
            break
          case 'MAX_SIZE_VIDEO':
            this.notify('25MB以上のビデオを利用することはできません。 サイズを調整してからアップロードしてください。')
            break
          case 'MAX_SIZE_IMAGE':
            this.notify('5MB以上の画像を利用することはできません。サイズを調整してからアップロードしてください。')
            break
          case 'INVALID_DIMENSION':
            this.notify(
              '画像・動画アップロードに失敗しました。',
              '詳しくは<a target="_blank" href="https://help-atelu.comnico.jp/available-image-and-video">こちら</a>をご確認ください。'
            )
            break
        }

        this.isMedia = false
        this.isUploadMediaLoading = false

        return
      }

      const formData = new FormData()
      formData.append('file', file)

      const data = await api.post('/media_uploads', formData, {
        headers: {
          'Content-Type': undefined
        }
      })

      this.isMedia = true

      const mediaType = file.type === 'video/mp4' ? 1 : 0

      this.setForm({
        ...this.form,
        mediaUrl: data.data.media_url,
        mediaOriginName: file.name,
        mediaType
      })

      this.isUploadMediaLoading = false
    },

    /**
     * メディアファイル削除
     */
    async removeMedia() {
      this.isMedia = false

      const removeData = {
        ...this.form,
        mediaUrl: null,
        mediaOriginName: null,
        mediaType: 0 as const
      }

      await this.setForm(removeData)
    },

    /**
     * タイトルを設定
     */
    async setPageName(value: string) {
      TrackingService.sendEvent('input:落選ページの作成|落選時テキスト')
      await this.setForm({ ...this.form, name: value })
      this.change('page_name')
    },
    /**
     * ページ落選時テキストを設定
     */
    async setPageLotteryText(value: string) {
      TrackingService.sendEvent('input:落選ページの作成|落選時テキスト')
      this.change('page_lose_text')
      await this.setForm({ ...this.form, lotteryText: value })
    },

    /**
     * テキストを変更チェック
     */
    async change(key: string) {
      switch (key) {
        case 'page_lose_text':
          this.isChangePageLoseText = true
          break
        case 'page_name':
          this.isChangePageName = true
          break
        default:
          break
      }
    },

    /**
     * ページタイトルを設定
     */
    async prevStep() {
      this.setMode('settings')
    },

    /**
     * エラーを表示
     */
    notify(title: string, message?: any, customClass = 'danger') {
      this.$notify({
        title,
        message,
        customClass,
        dangerouslyUseHTMLString: true,
        duration: 5000
      })
    },

    /**
     * 落選ページを作成・更新・複製
     */
    async createOrUpdatePage() {
      const body: Form = {
        mediaUrl: this.form.mediaUrl || WEB_INSTANTWIN_MEDIA_LOSE_URL,
        mediaOriginName: this.form.mediaOriginName || WEB_INSTANTWIN_MEDIA_LOSE_ORIGIN_NAME,
        name: this.form.name,
        lotteryText: this.form.lotteryText,
        lotteryType: 0,
        mediaType: this.form.mediaType
      }

      switch (this.mode) {
        case 'create':
          TrackingService.sendEvent('click:落選ページの作成|新規作成')
          break
        case 'edit_lose':
          TrackingService.sendEvent('click:落選ページの編集|保存')
          break
        case 'copy':
          TrackingService.sendEvent('click:落選ページの複製|複製')
          break
      }

      const response =
        this.mode === 'edit_lose' ? await this.fetchPutLotteryPages(body) : await this.fetchPostLotteryPages(body)

      if (!response || !response.data) {
        return this.notify('落選ページの保存に失敗しました。', '恐れ入りますが、時間をおいて再度お試しください。')
      }

      this.notify('落選ページを保存しました。', null, 'success')
      this.fetchLotteryPages()
    },

    /**
     * 落選ページの削除
     */
    async deletePage() {
      TrackingService.sendEvent('click:落選ページの編集|削除')

      const confirm = window.confirm('落選ページを削除してよろしいですか？')

      if (!confirm) {
        return
      }

      const response = await api.delete(`/twitter_lottery_pages/${this.form.twWebInstantwinLotteryPageSettingId}`, {
        params: {
          campaignId: this.form.campaignId
        }
      })

      if (!response || !response.data) {
        this.notify('落選ページの削除に失敗しました。', '恐れ入りますが、時間をおいて再度お試しください。')
        return
      }

      this.notify('落選ページを削除しました。', null, 'success')
      this.fetchLotteryPages()
    },

    /**
     * 落選ページの新規作成
     */
    async fetchPostLotteryPages(value: Form) {
      const body = {
        ...value,
        campaignId: this.form.campaignId,
        twCampaignPrizeId: this.form.twCampaignPrizeId
      }

      return await api.post('/twitter_lottery_pages', body)
    },

    /**
     * 落選ページの編集
     */
    async fetchPutLotteryPages(value: Form) {
      const body = {
        ...value,
        campaignId: this.form.campaignId
      }

      return await api.put(`/twitter_lottery_pages/${this.form.twWebInstantwinLotteryPageSettingId}`, body)
    }
  }
})
</script>
<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.condition-item .label {
  margin-bottom: $spacing-unit;
}

.title-container {
  display: flex;
  flex-direction: column;
  gap: $spacing-unit;
}

.campaign-create-condition {
  margin-top: $spacing-unit * 2;
}

.web-instanwin-page .input-container {
  display: flex;
  margin-top: $spacing-unit * 2;
}

.web-instanwin-page .label {
  width: 40%;
}

.create-web-instanwin-page {
  display: flex;
  justify-content: space-between;
  margin-top: $spacing-unit * 2;
}

.media-limit-text {
  display: block;
  margin-top: $spacing-unit;
}

.media-preview {
  position: relative;
  display: inline-block;
  padding: math.div($spacing-unit, 2) $spacing-unit;
  border: 1px solid $border-color;
  border-radius: $round;

  .media-name {
    padding-right: $spacing-unit * 3;
  }

  .mdi {
    position: absolute;
    top: math.div($spacing-unit, 2);
    right: math.div($spacing-unit, 2);
    cursor: pointer;
  }
}

.web-instanwin-page-media {
  width: 100%;
}

.direct-media {
  max-width: 100%;
  max-height: $spacing-unit * 32;
}

.title-name-input-error {
  color: $danger-color;
}

.title-input-error {
  flex: 76%;
  margin-top: $spacing-unit;
  color: $danger-color;
}

.error-container {
  display: flex;
}

.empty-label {
  flex: 30%;
}

.mdi-help-circle {
  margin-left: $spacing-unit;
  font-size: 18px;
}

.web-instantwin-win-textarea {
  width: 100%;
  height: 100%;
}
</style>
